/**
 * Beschriftungen des Datenmodells: Rollen, Pakete, Freigabe-Modi, Reichweiten,
 * Untergründe, Schriften und die mitgelieferten Boardvorlagen.
 *
 * Diese Texte stehen bei den Konstanten, zu denen sie gehören — dort allerdings
 * nur noch als Schlüssel. So bleibt an einer Stelle nachlesbar, welche Rollen es
 * gibt, und an einer anderen, wie sie in beiden Sprachen heißen.
 */
export const domain = {
    // --- Rollen in einer Organisation -----------------------------------------
    'role.admin': 'Verwaltung',
    'role.member': 'Mitglied',
    'role.admin.hint': 'Darf Personen aufnehmen und entfernen, Vorlagen der Organisation pflegen und sie umbenennen.',
    'role.member.hint': 'Darf Boards anlegen, bearbeiten, freigeben und präsentieren.',
    // --- Sichtbarkeit eines Boards --------------------------------------------
    'visibility.private': 'Nur ausgewählte Personen',
    'visibility.organisation': 'Alle in der Organisation',
    // --- Pakete ----------------------------------------------------------------
    'plan.demo': 'Demo',
    'plan.demo.hint': 'Zum Ausprobieren. Wird regelmäßig zurückgesetzt.',
    'plan.klein': 'Klein',
    'plan.klein.hint': 'Für einzelne Beratende und kleine Büros.',
    'plan.team': 'Team',
    'plan.team.hint': 'Für Agenturen, die gemeinsam an Boards arbeiten.',
    'plan.gross': 'Groß',
    'plan.gross.hint': 'Für Häuser mit mehreren Teams und vielen Medien.',
    // --- Lizenzzustand ---------------------------------------------------------
    'license.state.aktiv': 'Aktiv',
    'license.state.laeuft-ab': 'Läuft ab',
    'license.state.abgelaufen': 'Abgelaufen',
    'license.state.loeschung-faellig': 'Zur Löschung fällig',
    'license.notice.expiring.one': 'Die Lizenz läuft in {count} Tag ab. Danach lassen sich keine neuen Boards mehr anlegen.',
    'license.notice.expiring.many': 'Die Lizenz läuft in {count} Tagen ab. Danach lassen sich keine neuen Boards mehr anlegen.',
    'license.notice.expired.one': 'Die Lizenz ist abgelaufen. Vorhandene Boards bleiben nutzbar, Neues lässt sich nicht mehr anlegen. In {count} Tag werden die Daten zur Löschung vorgemerkt.',
    'license.notice.expired.many': 'Die Lizenz ist abgelaufen. Vorhandene Boards bleiben nutzbar, Neues lässt sich nicht mehr anlegen. In {count} Tagen werden die Daten zur Löschung vorgemerkt.',
    'license.notice.deletion': 'Die Lizenz ist seit über drei Wochen abgelaufen. Diese Organisation ist zur Löschung vorgemerkt — bitte umgehend bei Digitalwart melden.',
    'license.expired.short': 'Die Lizenz dieser Organisation ist abgelaufen.',
    // --- Eingebaute Schriften --------------------------------------------------
    'font.sans': 'Grotesk (Standard)',
    'font.serif': 'Serif',
    'font.grotesk': 'Schmal',
    'font.mono': 'Monospace',
    'font.rounded': 'Rund',
    // --- Freigabe-Modi ---------------------------------------------------------
    'share.explore.label': 'Freie Ansicht',
    'share.explore.description': 'Der Gast bewegt sich frei über das Board und kann die Frames selbst ansteuern. Ändern kann er nichts.',
    'share.guided.label': 'Geführt, mit Bewegungsfreiheit',
    'share.guided.description': 'Der Gast sieht das Board erst, wenn die Präsentation beginnt, und folgt dann deiner Ansicht. Er kann sich lösen und jederzeit zurückkehren.',
    'share.locked.label': 'Streng geführt',
    'share.locked.description': 'Wie „Geführt", aber der Gast kann sich nicht lösen: Er sieht ausschließlich das, was du zeigst.',
    // --- Reichweite einer Vorlage ----------------------------------------------
    'scope.personal': 'Nur für mich',
    'scope.personal.hint': 'Bleibt in deiner eigenen Liste, andere sehen sie nicht.',
    'scope.organisation': 'Für die Organisation',
    'scope.organisation.hint': 'Alle Mitglieder dieser Organisation können sie einsetzen.',
    'scope.platform': 'Für alle Organisationen',
    'scope.platform.hint': 'Standardvorlage des Betreibers — in jeder Organisation verfügbar.',
    // --- Untergründe -----------------------------------------------------------
    'background.black': 'Tiefschwarz',
    'background.anthracite': 'Anthrazit',
    'background.night': 'Nachtblau',
    'background.warmgrey': 'Warmgrau',
    'background.slate': 'Schiefer',
    'background.sand': 'Sand',
    'background.paper': 'Papier',
    'background.white': 'Reinweiß',
    // --- Fensterbreiten für eingebettete Websites ------------------------------
    'viewport.monitor': 'Großer Monitor',
    'viewport.desktop': 'Desktop',
    'viewport.laptop': 'Laptop',
    'viewport.tabletLandscape': 'Tablet quer',
    'viewport.tablet': 'Tablet',
    'viewport.phone': 'Handy',
    // --- Mitgelieferte Boardvorlagen -------------------------------------------
    // Die Frame-Namen landen als Inhalt im Board. Sie werden deshalb in der
    // Sprache eingesetzt, die beim Anlegen gilt — und ändern sich danach nicht
    // mehr mit, wie es sich für Inhalt gehört.
    'bt.talk': 'Vortrag',
    'bt.talk.title': 'Titel',
    'bt.talk.agenda': 'Agenda',
    'bt.talk.topic1': 'Thema 1',
    'bt.talk.topic2': 'Thema 2',
    'bt.talk.topic3': 'Thema 3',
    'bt.talk.conclusion': 'Fazit',
    'bt.talk.questions': 'Fragen',
    'bt.client': 'Kundentermin',
    'bt.client.welcome': 'Begrüßung',
    'bt.client.situation': 'Ausgangslage',
    'bt.client.proposal': 'Vorschlag',
    'bt.client.delivery': 'Umsetzung',
    'bt.client.effort': 'Aufwand',
    'bt.client.next': 'Nächste Schritte',
    'bt.workshop': 'Workshop',
    'bt.workshop.arrive': 'Ankommen',
    'bt.workshop.goal': 'Ziel des Tages',
    'bt.workshop.rules': 'Spielregeln',
    'bt.workshop.space1': 'Arbeitsfläche 1',
    'bt.workshop.space2': 'Arbeitsfläche 2',
    'bt.workshop.parking': 'Parkplatz',
    'bt.workshop.results': 'Ergebnisse',
    'bt.lesson': 'Lehreinheit',
    'bt.lesson.start': 'Einstieg',
    'bt.lesson.goals': 'Lernziele',
    'bt.lesson.work': 'Erarbeitung',
    'bt.lesson.practice': 'Übung',
    'bt.lesson.secure': 'Sicherung',
    'bt.lesson.outlook': 'Ausblick',
    'bt.mood': 'Moodboard',
    'bt.mood.direction': 'Richtung',
    'bt.mood.colors': 'Farben',
    'bt.mood.type': 'Typografie',
    'bt.mood.imagery': 'Bildsprache',
    'bt.mood.references': 'Vorbilder',
    'bt.mood.boundaries': 'Abgrenzung',
    'bt.canvas': 'Große Leinwand',
    'bt.canvas.frame': 'Leinwand',
};
//# sourceMappingURL=domain.js.map